<!-- Kabuk canlandırma (02.10.2026): eski hâli
<div class="modules-container">
  <div class="search-header">
    <div class="search-container">
      <dx-text-box
        [value]="searchControl.value"
        (onValueChanged)="onSearchValueChanged($event)"
        (onEnterKey)="onSearch()"
        placeholder="Uygulama ara..."
        [showClearButton]="true"
        class="search-input">
      </dx-text-box>
      <dx-button
        icon="search"
        (onClick)="onSearch()"
        [stylingMode]="'contained'"
        type="default"
        class="search-button">
      </dx-button>
    </div>
  </div>

  <div class="content-area">
    <dx-tile-view
      #tileView
      class="dx-tile-content"
      itemTemplate="list-item"
      direction="vertical"
      [items]="filteredModulelist$ | async">
      <div *dxTemplate="let data of 'list-item'; let index = index" (click)="onItemClick(data)" class="module-card">
        <div class="icon-wrapper">
          <i class="dx-icon dx-icon-{{data.icon}}"></i>
        </div>
        <div class="title">{{ data.menuTitle }}</div>
      </div>
    </dx-tile-view>
  </div>
</div>
-->
<div class="am" *ngIf="gorunum$ | async as g">
  <div class="am-vitrin">
    <span class="am-kabarcik"></span>
    <div class="am-vitrin-ust">
      <span class="am-vitrin-ikon"><i class="dx-icon dx-icon-mediumiconslayout"></i></span>
      <div class="am-vitrin-yazi">
        <h3>Uygulamalar</h3>
        <p>{{ g.arama ? g.moduller.length + ' sonuç' : g.moduller.length + ' modül · çalışmak istediğinizi seçin' }}</p>
      </div>
      <button *ngIf="g.tumu" type="button" class="am-cam-btn" (click)="onItemClick(g.tumu)">
        <i class="dx-icon dx-icon-hierarchy"></i>Tüm menüyü göster
      </button>
    </div>
    <label class="am-ara">
      <i class="dx-icon dx-icon-search"></i>
      <input
        #aramaKutusu
        type="text"
        placeholder="Uygulama ara…"
        autocomplete="off"
        [value]="searchControl.value"
        (input)="onSearchValueChanged({ value: aramaKutusu.value })"
        (keydown.enter)="ilkSonucuAc(g.moduller)"
      />
      <i *ngIf="g.arama" class="dx-icon dx-icon-clear am-ara-temizle" (click)="aramayiTemizle(); aramaKutusu.focus()"></i>
    </label>
  </div>

  <div class="am-govde">
    <button
      *ngFor="let m of g.moduller; let i = index; trackBy: modulKodu"
      type="button"
      class="am-kart"
      [class.secili]="m.moduleId === aktifModulId"
      [style.--r]="m.renk"
      [style.--i]="i"
      [title]="m.menuTitle"
      (click)="onItemClick(m)"
    >
      <span class="am-kart-ikon"><i class="dx-icon" [ngClass]="m.ikonSinif"></i></span>
      <span class="am-kart-ad">
        <ng-container *ngFor="let p of m.parcalar"><mark *ngIf="p.eslesme; else duz">{{ p.metin }}</mark><ng-template #duz>{{ p.metin }}</ng-template></ng-container>
      </span>
      <span *ngIf="m.moduleId === aktifModulId" class="am-rozet">Açık</span>
      <span class="am-git"><i class="dx-icon dx-icon-arrowright"></i></span>
    </button>
    <div *ngIf="!g.moduller.length" class="am-bos">“{{ g.arama }}” ile eşleşen uygulama yok.</div>
  </div>
</div>
